import { RecordCircleIcon } from "@vericus/cadmus-icons";
import { Button, colors, Skeleton, Text } from "@vericus/cadmus-ui";

import { RecordingStartCutoffTip } from "@/features/socratic/components/recording-start-cutoff-tip";
import { useRecordingGate } from "@/features/socratic/hooks";

import * as styles from "./start-dialogue-cta.css";

type Props = {
  onStartPressed: () => void;
  loading?: boolean;
  isReadonly?: boolean;
  numAttemptsRemaining: number;
  hasPreparationTime?: boolean;
};

export function StartDialogueCTA({
  onStartPressed,
  loading = false,
  isReadonly = false,
  numAttemptsRemaining,
  hasPreparationTime = false,
}: Props) {
  const { hasAutoSubmission, wouldAutoSubmitDuringRecording } =
    useRecordingGate();

  const startDisabled =
    loading ||
    isReadonly ||
    wouldAutoSubmitDuringRecording ||
    numAttemptsRemaining <= 0;

  return (
    <div className={styles.box}>
      <div className={styles.main}>
        <Button
          kind="secondary"
          icon={
            <RecordCircleIcon
              label=""
              size={24}
              color={startDisabled ? colors.sgrey400 : colors.poppy500}
            />
          }
          onClick={onStartPressed}
          disabled={startDisabled}
        >
          START
        </Button>
        <Text kind="bodyMd" color="navy700">
          Click Start to submit a response.{" "}
          {hasPreparationTime
            ? "Your preparation time will start immediately."
            : "Your response time will start immediately."}
        </Text>
      </div>
      {!isReadonly && numAttemptsRemaining > 0 && (
        <RecordingStartCutoffTip
          isFirstAttempt
          hasAutoSubmission={hasAutoSubmission}
        />
      )}
    </div>
  );
}

export function StartDialogueCTASkeleton() {
  return <Skeleton width={14.5} height={40} />;
}
